import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/lib/require-supabase-auth.server";
import type { StripeEnv } from "@/lib/stripe.server";
import type { ReadinessReport } from "@/lib/payments-readiness.server";

/**
 * Live/sandbox payment readiness. Admin-only: the report reveals internal
 * Stripe configuration state and triggers outbound Stripe API calls, so the
 * caller must be authenticated and hold the admin role.
 */
export const getPaymentsReadiness = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data: { environment: StripeEnv }) => {
    if (data.environment !== "live" && data.environment !== "sandbox") {
      throw new Error("Invalid environment");
    }
    return data;
  })
  .handler(async ({ data, context }): Promise<ReadinessReport> => {
    const { data: isAdmin, error: roleError } = await context.supabase.rpc("has_role", {
      _user_id: context.userId,
      _role: "admin",
    });
    if (roleError) throw roleError;
    if (!isAdmin) throw new Error("Forbidden");

    const { runReadinessReport } = await import("@/lib/payments-readiness.server");
    return runReadinessReport(data.environment);
  });
